import { Section } from "../components/common/Section/Section";
import { DevEx } from "../components/sections/DevEx/DevEx";
import { Footer } from "../components/sections/Footer/Footer";
import { Header } from "../components/sections/Header/Header";
import { Hero } from "../components/sections/Hero/Hero";
import { OurProduct } from "../components/sections/OurProduct/OurProduct";
import { Astrolabe } from "../components/sections/Astrolabe/Astrolabe";
import { OurTeam } from "../components/sections/OurTeam/OurTeam";
import { ContactUs } from "../components/sections/ContactUs/ContactUs";
import { useEffect, useState } from "react";
export const MainLayout = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <Header />
            <Section name="home" backgroundColor="#021a1a">
                <Hero />
            </Section>
            <Section name="product" backgroundColor="#021a1a">
                <OurProduct />
            </Section>
            <Section name="devex" backgroundColor="#002322">
                <DevEx />
            </Section>
            <Section name="astrolabe" backgroundColor="#021a1a">
                <Astrolabe />
            </Section>
            <Section name="team" backgroundColor="#021a1a" marginBottom='91px'>
                <OurTeam />
            </Section>
            <Section name="contact" backgroundColor="#002322" marginBottom={isMobile ? '252px' : '335px'}>
                <ContactUs />
            </Section>
            <Section name="footer" backgroundColor="#021a1a" customWidth='100%'>
                <Footer />
            </Section>
        </>
    );
};
